module.exports = __webpack_public_path__ + "img/cx_medida_pressao.60137a7d.webp";